export const ERROR_MESSAGES = {
	INSUFFICIENT_CASHLESS_BALANCE: "Insufficient cashless balance.",
	MEMBERSHIP_EXPIRED: "Membership expired.",
	SELECT_MEMBERSHIP_CLIENT: "Select a membership client.",
	ENTER_VALID_AMOUNT: "Enter a valid amount.",
	ENTER_AMOUNT_TO_CHARGE: "Enter amount to charge.",
};

export const PAYMENT_IN_PROGRESS_MESSAGE = "Payment is in progress. Changes to services, add-ons, and discounts can't be made.";
export const COMPLETE_BOOKING_WARNING_MESSAGE = "Sales will remain unchanged";